/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { LeftSide } from './LeftSide'
import { RightSidebar } from './RightSidebar'
import TopBar from '../../components/TopBar'
import { createBlog, updateBlog, deleteBlogs, getBlog } from '../../api/blogApi'
import { getAllBanners } from '../../api/bannerApi'
import { getAllBlogCategories } from '../../api/blogCategoryApi'
import DeleteConfirmationPopup from '../../components/DeleteConfirmationPopup'
import useMediaUpload from '../../hooks/useMediaUpload'

import styles from './blog.module.css'
import UploadMediaPopup from '../../components/UploadMediaPopup'

const NewPost = () => {
    const { blogId } = useParams();
    const navigate = useNavigate();
    const deletePopupRef = useRef();

    const [showUploadMediaPopup, setShowUploadMediaPopup] = useState(false);
    const [uploadMediaPopupFor, setUploadMediaPopupFor] = useState('');
    const [uploadMediaPopupTab, setUploadMediaPopupTab] = useState('upload');
    const [selectedFeatureImage, setSelectedFeatureImage] = useState(null);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [isImageDragging, setIsImageDragging] = useState(false);

    /* --- Editor state --- */
    const [updatedContent, setUpdatedContent] = useState("");
    const [editorContent, setEditorContent] = useState("");

    /* --- Blog data state --- */
    const [blogData, setBlogData] = useState({
        title: '',
        slug: '',
        status: 'draft',
        bannerId: [],
        featureImage: null,
        categoryId: [],
        seoContent: '',
        seoTitle: '',
        keyword: ''
    });
    const [isSlugChanged, setIsSlugChanged] = useState(false);
    const [errorMessage, setErrorMessage] = useState({});

    /* --- Button state --- */
    const [published, setPublished] = useState(false);
    const [draft, setDraft] = useState(false);
    const [isPublishedOpen, setIsPublishedOpen] = useState(false);
    const [isDraftOpen, setIsDraftOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isDraftLoading, setIsDraftLoading] = useState(false);
    const [isDeleteLoading, setIsDeleteLoading] = useState(false);

    /* --- Banners & Categories --- */
    const bannerDropdownRef = useRef();
    const [bannerList, setBannerList] = useState([]);
    const [openBanner, setOpenBanner] = useState(false);

    const [categoryList, setCategoryList] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [searchCategory, setSearchCategory] = useState('');

    /* --- Media upload for featured image --- */
    const fileList = {
        'image/jpeg': true,
        'image/png': true,
        'image/jpg': true
    };
    const { handleMeidaUpload } = useMediaUpload(setSelectedFeatureImage, null, fileList);

    useEffect(() => {
        const checkIfClickedOutside = (event) => {
            if (bannerDropdownRef.current && !bannerDropdownRef.current.contains(event.target)) {
                setOpenBanner(false);
            }
            if (deletePopupRef.current && !deletePopupRef.current.contains(event.target)) {
                setShowDeletePopup(false);
            }
        };
        document.addEventListener("mousedown", checkIfClickedOutside);
        return () => {
            document.removeEventListener("mousedown", checkIfClickedOutside);
        };
    }, []);

    useEffect(() => {
        if (selectedFeatureImage) {
            setBlogData(prev => ({ ...prev, featureImage: selectedFeatureImage }));
            setErrorMessage(prev => ({ ...prev, featureImage: '' }));
        }
    }, [selectedFeatureImage]);


    useEffect(() => {
        const fetchBannerData = async () => {
            try {
                const response = await getAllBanners();
                setBannerList(response?.data || []);
            } catch (error) {
                setBannerList([]);
            }
        };
        fetchBannerData();
    }, []);

    const getSingleBlog = async () => {
        try {
            const response = await getBlog(blogId);
            if (response?.success) {
                const blogItem = response?.data || {};
                setSelectedFeatureImage(blogItem?.featureImage !== '' ? [blogItem?.featureImage] : null)

                const responseBanner = await getAllBanners();
                const selectedBanner = responseBanner?.data?.filter((item) =>
                    blogItem?.bannerId?.some((banner) => item.bannerId === banner)
                );

                const blogDataItem = {
                    ...blogItem,
                    bannerId: selectedBanner?.length > 0 ? selectedBanner : []
                }

                setBlogData(blogDataItem);

                setEditorContent(
                    blogItem?.description === "<p></p>" ? "" : blogItem?.description
                );
                setUpdatedContent(
                    blogItem?.description === "<p></p>" ? "" : blogItem?.description
                );

                // Fetch all categories to set selectedCategories objects
                const allCategoriesRes = await getAllBlogCategories();
                const allCategories = allCategoriesRes?.data || [];
                setCategoryList(allCategories);

                const selectedCats = allCategories.filter(cat =>
                    blogItem?.categoryId?.includes(cat?.categoryId)
                );
                setSelectedCategories(selectedCats);

                if (blogItem?.status === "published") {
                    setPublished(true);
                    setDraft(false);
                } else if (blogItem?.status === "draft") {
                    setDraft(true);
                    setPublished(false);
                }
            }
        } catch (error) {
            console.log({ error });
        }
    };

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await getAllBlogCategories();
                console.log({ response })
                setCategoryList(response?.data || []);
            } catch (error) {
                setCategoryList([]);
            }
        };
        fetchCategories();
    }, []);

    useEffect(() => {
        if (blogId && blogId !== undefined && blogId !== '') {
            getSingleBlog();
        }
    }, [blogId]);

    const handleBannerSelect = (banner) => {
        setBlogData(prev => {
            const currentBanners = Array.isArray(prev?.bannerId) ? prev.bannerId : (prev?.bannerId ? [prev.bannerId] : []);
            const exists = currentBanners.some(b => b?.bannerId === banner?.bannerId);
            let newBanners;
            if (exists) {
                newBanners = currentBanners.filter(b => b?.bannerId !== banner?.bannerId);
            } else {
                newBanners = [...currentBanners, banner];
            }
            return { ...prev, bannerId: newBanners };
        });
    };

    const handleContentChange = (newContent) => {
        setUpdatedContent(newContent);
        setErrorMessage((prev) => ({
            ...prev,
            description: ''
        }));
    };

    function convertToSlug(str) {
        let slug = str.toLowerCase();
        slug = slug.trim();
        slug = slug.replace(/[^a-z0-9\s-]/g, '');
        slug = slug.replace(/\s+/g, '-');
        return slug;
    }

    const changeSlug = (value) => {
        if (!isSlugChanged) {
            let urlValue = convertToSlug(value);
            setBlogData({ ...blogData, slug: urlValue });
        }
    };

    const changeTitle = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            return true;
        }
    };

    const changesTitles = (e) => {
        const text = e.target.innerText.replace(/<[^>]+>/g, '');
        if (text.length <= 120 || e.key === 'Backspace') {
            changeSlug(text);
        } else {
            e.preventDefault();
            return true;
        }
    };

    const handleBlur = (e) => {
        const text = e.target.innerText.replace(/<[^>]+>/g, '').trim();
        setBlogData({ ...blogData, title: text })
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const clipboardData = e.clipboardData.getData('text/plain');
        document.execCommand('insertText', false, clipboardData);
    };

    /* --- Category handling --- */
    const handleCategoryChange = (category) => {
        setSelectedCategories(prev => {
            if (prev.includes(category)) {
                const filtered = prev.filter(c => c !== category);
                return filtered.length === 0 ? [] : filtered;
            } else {
                return prev?.length === 0
                    ? [category]
                    : [...prev, category];
            }
        });
    };

    const filteredCategories = (categoryList || []).filter((category) => {
        return (category?.name || "")
            .toLowerCase()
            .includes((searchCategory || "").toLowerCase());
    });

    /* --- Validation --- */
    const validatePublishBlog = () => {
        const errors = {};
        if (!blogData?.title?.trim()) {
            errors.title = "Title is required";
        }
        const content = updatedContent || editorContent;
        if (!content || !content.trim() || content === "<p></p>") {
            errors.description = "Description is required";
        }
        if (!blogData?.slug?.trim()) {
            errors.slug = "URL is required";
        }
        if (!blogData?.featureImage) {
            errors.featureImage = "Feature Image is required";
        }
        if (selectedCategories.length === 0) {
            errors.category = "At least one category is required";
        }
        setErrorMessage(errors);
        return Object.keys(errors).length === 0;
    };

    const validateDraftBlog = () => {
        const errors = {};
        if (!blogData?.title?.trim()) {
            errors.title = "Title is required";
        }
        setErrorMessage(errors);
        return Object.keys(errors).length === 0;
    };

    /* --- Submit handlers --- */
    const handlePublish = async () => {
        if (!validatePublishBlog()) return;
        setIsLoading(true);
        try {
            const payload = {
                title: blogData.title,
                description: updatedContent || editorContent,
                slug: blogData.slug,
                status: 'published',
                bannerId: blogData?.bannerId && Array.isArray(blogData?.bannerId) ? blogData?.bannerId?.map(banner => banner?.bannerId) : null,
                featureImage: selectedFeatureImage?.[0]?.id,
                categoryId: selectedCategories.map(cat => cat?.categoryId),
                categories: undefined,
                banners: undefined,
                seoContent: blogData?.seoContent || '',
                seoTitle: blogData?.seoTitle || '',
                keyword: blogData?.keyword || ''
            };
            if (blogId) {
                await updateBlog(blogId, payload);
            } else {
                const response = await createBlog(payload);
                if (response?.success) {
                    navigate(`/blog/${response?.data?.blogId}`);
                }
            }
            setPublished(true);
            setDraft(false);
        } catch (error) {
            console.log(error);
            if (error?.response?.data?.error?.message === "Blog slug already exists") {
                setErrorMessage({ ...errorMessage, slug: "Slug already exists" });
            }
        }
        setIsLoading(false);
    };

    const handleDraft = async () => {
        if (!validateDraftBlog()) return;
        setIsDraftLoading(true);
        try {
            const payload = {
                title: blogData.title,
                description: updatedContent || editorContent,
                slug: blogData.slug,
                status: 'draft',
                bannerId: blogData?.bannerId && Array.isArray(blogData?.bannerId) ? blogData?.bannerId?.map(banner => banner?.bannerId) : null,
                featureImage: selectedFeatureImage?.[0]?.id || null,
                categoryId: selectedCategories.map(cat => cat?.categoryId),
                categories: undefined,
                banners: undefined,
                seoContent: blogData?.seoContent || '',
                seoTitle: blogData?.seoTitle || '',
                keyword: blogData?.keyword || '',
            };
            if (blogId) {
                await updateBlog(blogId, payload);
            } else {
                const response = await createBlog(payload);
                if (response?.success) {
                    navigate(`/blog/${response?.data?.blogId}`);
                }
            }
            setDraft(true);
            setPublished(false);
        } catch (error) {
            console.log(error);
            if (error?.response?.data?.error?.message === "Blog slug already exists") {
                setErrorMessage({ ...errorMessage, slug: "Slug already exists" });
            }
        }
        setIsDraftLoading(false);
        setIsLoading(false);
    };

    const handleChangeToDraft = async () => {
        if (published && blogId) {
            setIsLoading(true);
            try {
                const payload = {
                    ...blogData,
                    status: 'draft',
                    bannerId: blogData?.bannerId && Array.isArray(blogData?.bannerId) ? blogData?.bannerId?.map(banner => banner?.bannerId) : null,
                    featureImage: selectedFeatureImage?.[0]?.id || null,
                    categoryId: selectedCategories.map(cat => cat?.categoryId),
                    categories: undefined,
                    banners: undefined,
                };
                await updateBlog(blogId, payload);
                setPublished(false);
                setDraft(true);
                setIsPublishedOpen(false);
            } catch (error) {
                console.log(error);
            if (error?.response?.data?.error?.message === "Blog slug already exists") {
                setErrorMessage({ ...errorMessage, slug: "Slug already exists" });
            }
            }
            setIsLoading(false);
        }
    };

    const handleChangeToPublish = async () => {
        if (draft && blogId) {
            if (!validatePublishBlog()) return;
            setIsLoading(true);
            try {
                const payload = {
                    ...blogData,
                    status: 'published',
                    bannerId: blogData?.bannerId && Array.isArray(blogData?.bannerId) ? blogData?.bannerId?.map(banner => banner?.bannerId) : null,
                    featureImage: selectedFeatureImage?.[0]?.id,
                    categoryId: selectedCategories.map(cat => cat?.categoryId),
                    categories: undefined,
                    banners: undefined,
                };
                await updateBlog(blogId, payload);
                setDraft(false);
                setPublished(true);
                setIsDraftOpen(false);
            } catch (error) {
                console.log(error);
            if (error?.response?.data?.error?.message === "Blog slug already exists") {
                setErrorMessage({ ...errorMessage, slug: "Slug already exists" });
            }
            }
            setIsLoading(false);
        }
    };

    const handelSingleDelete = async () => {
        setShowDeletePopup(true);
    };

    const confirmDelete = async () => {
        try {
            if (blogId) {
                setIsDeleteLoading(true)
                const response = await deleteBlogs([blogId]);
                if (response?.success) {
                    setShowDeletePopup(false)
                    navigate('/blog');
                    setIsDeleteLoading(false)
                }
            }
        } catch (error) {
            setIsDeleteLoading(false)
            console.log(error);
        }
    };

    const handleFileDragOver = (e) => {
        e.preventDefault();
        setIsImageDragging(true);
    };

    const handleFileDragLeave = (e) => {
        e.preventDefault();
        setIsImageDragging(false);
    };

    const handleFeatureImageDrop = async (e) => {
        e.preventDefault();
        const files = e.dataTransfer.files;
        const maxSizeInBytes = 128 * 1024 * 1024;
        const allowedFileTypes = ['image/jpeg', 'image/png', 'image/jpg'];
        const validFiles = Array.from(files).filter(file => {
            if (!allowedFileTypes.includes(file.type)) return false;
            if (file.size > maxSizeInBytes) return false;
            return true;
        }).slice(0, 1);
        handleMeidaUpload(validFiles);
        setIsImageDragging(false);
    };

    return (
        <>
            <TopBar />
            <div className={styles.contentWrapper}>
                <div className={styles.newpageContent}>
                    <LeftSide
                        styles={styles}
                        blogData={blogData}
                        setBlogData={setBlogData}
                        changeSlug={changeSlug}
                        changeTitle={changeTitle}
                        changesTitles={changesTitles}
                        handleBlur={handleBlur}
                        handlePaste={handlePaste}
                        errorMessage={errorMessage}
                        setErrorMessage={setErrorMessage}
                        editorContent={editorContent}
                        setEditorContent={setEditorContent}
                        handleContentChange={handleContentChange}
                        blogId={blogId}
                    />
                    <RightSidebar
                        styles={styles}
                        blogData={blogData}
                        setBlogData={setBlogData}
                        setIslugChanged={setIsSlugChanged}
                        changeSlug={changeSlug}
                        convertToSlug={convertToSlug}
                        errorMessage={errorMessage}
                        setErrorMessage={setErrorMessage}
                        published={published}
                        draft={draft}
                        isPublishedOpen={isPublishedOpen}
                        setIsPublishedOpen={setIsPublishedOpen}
                        isDraftOpen={isDraftOpen}
                        setIsDraftOpen={setIsDraftOpen}
                        isLoading={isLoading}
                        isDraftLoading={isDraftLoading}
                        handlePublish={handlePublish}
                        handleDraft={handleDraft}
                        handleChangeToDraft={handleChangeToDraft}
                        handleChangeToPublish={handleChangeToPublish}
                        handelSingleDelete={handelSingleDelete}
                        blogId={blogId}
                        setIsDraftLoading={setIsDraftLoading}
                        setIsLoading={setIsLoading}
                        validateDraftPage={validateDraftBlog}
                        bannerList={bannerList}
                        handleBannerSelect={handleBannerSelect}
                        bannerDropdownRef={bannerDropdownRef}
                        openBanner={openBanner}
                        setOpenBanner={setOpenBanner}
                        categoryList={categoryList}
                        selectedCategories={selectedCategories}
                        setSelectedCategories={setSelectedCategories}
                        handleCategoryChange={handleCategoryChange}
                        searchCategory={searchCategory}
                        setSearchCategory={setSearchCategory}
                        selectedFeatureImage={selectedFeatureImage}
                        setSelectedFeatureImage={setSelectedFeatureImage}
                        showUploadMediaPopup={showUploadMediaPopup}
                        setShowUploadMediaPopup={setShowUploadMediaPopup}
                        uploadMediaPopupFor={uploadMediaPopupFor}
                        setUploadMediaPopupFor={setUploadMediaPopupFor}
                        uploadMediaPopupTab={uploadMediaPopupTab}
                        setUploadMediaPopupTab={setUploadMediaPopupTab}
                        isImageDragging={isImageDragging}
                        setImageDragging={setIsImageDragging}
                        handleFeatureImageDrop={handleFeatureImageDrop}
                        handleFileDragOver={handleFileDragOver}
                        handleFileDragLeave={handleFileDragLeave}
                        handleMeidaUpload={handleMeidaUpload}
                        filteredCategories={filteredCategories}
                    />
                </div>
            </div>
            {showUploadMediaPopup &&
                <UploadMediaPopup showUploadMediaPopup={showUploadMediaPopup} setShowUploadMediaPopup={setShowUploadMediaPopup} setSelectedProfileImage={setSelectedFeatureImage} uploadMediaPopupFor={uploadMediaPopupFor} uploadMediaPopupTab={uploadMediaPopupTab} />
            }
            <DeleteConfirmationPopup
                showDeletePopup={showDeletePopup}
                setShowDeletePopup={setShowDeletePopup}
                reference={deletePopupRef}
                title={'blog'}
                description={'Are you sure you want to delete this blog? This action cannot be undone.'}
                confirmDelete={confirmDelete}
                isLoading={isDeleteLoading}
            />
        </>
    );
};

export default NewPost;
